import Vue from 'vue'
import Vuex from 'vuex'

import { alert } from './modules/alert';
import { user } from './modules/user';
import { creator } from './modules/creator';
import { file } from './modules/file';
import { app } from './modules/app';

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  modules: {
    app,
    user,
    alert,
    creator,
    file
  },
  state: {
    history: [],
  },
  getters: {
  },
  mutations: {
  },
})
